// @ts-nocheck
import { StyleSpecification } from 'maplibre-gl'

import { BASE_LAYERS } from './BASE_LAYERS'

export const MAP_STYLE: StyleSpecification = {
    version: 8,
    name: 'Shovel',
    metadata: { 'maputnik:renderer': 'mlgljs' },
    sources: {
        'natural-earth': {
            type: 'vector',
            url: 'https://gooje.app/base-map/natural-earth',
        },
        'natural-earth-raster': {
            type: 'raster',
            url: 'https://gooje.app/base-map/natural-earth-raster',
        },
        iran: { type: 'vector', url: 'https://gooje.app/base-map/iran-old' },
        wheat: {
            type: 'vector',
            tiles: ['apex:///api/wheat/display/{z}-{x}-{y}'],
            minzoom: 0,
            maxzoom: 18,
        },
        gsat: {
            type: 'raster',
            tiles: ['gsat://{z}-{x}-{y}'],
        },
        gvec: {
            type: 'raster',
            tiles: ['gvec://{z}-{x}-{y}'],
        },
        selected: {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: [],
            },
        },
        hillshade: {
            type: 'raster-dem',
            tiles: ['https://gooje.app/map-hillshade/{z}-{x}-{y}.webp'],
            // tileSize: 512,
            minzoom: 0,
            // maxzoom: 15,
            maxzoom: 11,
        },
        farm: {
            type: 'vector',
            url: '/tilejson/',
        },
    },
    sprite: 'https://gooje.app/base-map/sprite/light',
    glyphs: 'https://gooje.app/base-map/font/{fontstack}/{range}',
    id: 'shovel-map',
    layers: [
        // {
        //     id: 'background',
        //     type: 'background',
        //     minzoom: 3,
        //     paint: {
        //         'background-color': 'rgba(35, 35, 35, 1)',
        //         // 'background-color': '#ffffff',
        //         'background-opacity': 1,
        //     },
        // },
        // @ts-ignore
        ...BASE_LAYERS,

        {
            id: 'fill gvec',
            type: 'raster',
            source: 'gvec',
            layout: { visibility: 'none' },
        },

        {
            id: 'hillshading',
            source: 'hillshade',
            type: 'hillshade',
            // maxzoom: 9,
            paint: {},
        },

        {
            id: 'poi',
            type: 'symbol',
            source: 'iran',
            'source-layer': 'poi',
            minzoom: 0,
            layout: {
                'text-font': ['Vazir Regular'],
                'text-field': '{name}',
                visibility: 'none',
                'text-size': 16,
            },
        },
        {
            id: 'wheat-display',
            type: 'fill',
            source: 'wheat',
            'source-layer': 'wheat_display',
            minzoom: 0,
            paint: {
                // 'fill-color': 'lime',
                'fill-color': [
                    'match',
                    ['get', 'kind'],
                    0,
                    '#ff0000',
                    1,
                    '#ff69b4',
                    2,
                    '#8b4513',
                    3,
                    '#ffff00',
                    4,
                    '#0000ff',
                    'lime',
                ],
                'fill-opacity': 0.2,
                'fill-outline-color': 'black',
            },
        },

        {
            id: 'wheat-display-updated',
            type: 'fill',
            source: 'wheat',
            'source-layer': 'wheat_display',
            minzoom: 0,
            filter: ['all', ['has', 'updated'], ['>', ['get', 'updated'], 0]],
            paint: {
                'fill-color': '#00ffff',
                'fill-opacity': ['get', 'updated'],
                'fill-outline-color': 'black',
            },
        },

        {
            id: 'selected_mark',
            type: 'fill',
            source: 'selected',
            paint: {
                'fill-color': [
                    'match',
                    ['get', 'mark'],
                    'void',
                    '#ff0000',
                    'road',
                    '#0000ff',
                    'village',
                    '#ffff00',
                    'town',
                    '#8b4513',
                    'city',
                    '#ff69b4',
                    'lime',
                ],

                'fill-opacity': 0.5,
                'fill-outline-color': '#040404',
            },
        },

        {
            id: 'kernel-group bg 8-10',
            type: 'circle',
            source: 'farm',
            'source-layer': 'kernel_group',
            maxzoom: 11,
            paint: {
                'circle-radius': 50,
                'circle-color': '#3478f6',
                'circle-stroke-color': '#ffffff',
                'circle-stroke-width': 2,
            },
        },

        {
            id: 'kernel-group bg 11-end',
            type: 'circle',
            source: 'farm',
            'source-layer': 'kernel_group',
            minzoom: 11,
            paint: {
                'circle-radius': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    11,
                    2,
                    12,
                    3,
                    // 13, 4,
                    14,
                    8,
                    // 15, 16,
                    // 16, 24,
                    // 17, 49,
                    18,
                    48,
                ],
                // 'circle-color': '#1E5AA8',
                'circle-color': '#B8862D',
                'circle-stroke-color': '#ffffff',
                'circle-stroke-width': [
                    'interpolate',
                    ['linear'],
                    ['zoom'],
                    11,
                    0,
                    12,
                    0,
                    14,
                    2,
                ],
            },
        },

        {
            id: 'kernel-group big-text',
            type: 'symbol',
            source: 'farm',
            'source-layer': 'kernel_group',
            maxzoom: 11,
            // filter: ['all', ...DEFAULT_FILTERS, ['==', 'is_low_quality', true]],
            layout: {
                'text-font': ['Vazir Regular'],
                'text-field': '{count}',
                'text-allow-overlap': true,
                'text-anchor': 'center',
                'text-size': 26,
                visibility: 'visible',
            },
            paint: {
                'text-color': '#fff',
                // 'text-halo-color': '#fff',
                // 'text-halo-blur': 0,
                'text-translate': [0, 0],
                'text-opacity': 1,
            },
        },

        {
            id: 'kernel-group',
            type: 'symbol',
            source: 'farm',
            'source-layer': 'kernel_group',
            minzoom: 14,
            // filter: ['all', ...DEFAULT_FILTERS, ['==', 'is_low_quality', true]],
            layout: {
                'text-font': ['Vazir Regular'],
                'text-field': '{count}',
                'text-allow-overlap': true,
                'text-anchor': 'center',
                'text-size': 16,
                visibility: 'visible',
            },
            paint: {
                'text-color': '#000',
                // 'text-halo-color': '#fff',
                // 'text-halo-blur': 0,
                'text-translate': [0, 0],
                'text-opacity': 1,
            },
        },
    ],
}

// console.log(JSON.stringify(MAP_STYLE))
